import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss']
})
export class BankComponent {
isPontoFlow: boolean = false;
gpId: string;

  constructor(
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.gpId = this.activatedRoute.snapshot.params['gpId'];
    this.isPontoFlow = environment.enabledGPsForPonto.split(',').includes(this.gpId);
  }
}
